import React, {useCallback, useState} from 'react';
import {observer} from 'mobx-react-lite';

import {Button} from "core_src/components";
import {usePaywallStoreContext} from "./Store";
import {PaywallCard} from "./PaywallCard";
import {templateSettings} from "anvil_settings";


/**
 * Component for prompting a user to use one of their views to read an article.
 *
 * @param {string} pageUrl - The url of the page to read. This is used for analytics and for redirecting back to this
 *  page after logging in or linking a subscription.
 * @param {function} readArticleHandler - Function to be called when the read article button is clicked.
 */

export const ReadArticle = observer(({pageUrl, readArticleHandler}) => {
        const paywallStore = usePaywallStoreContext();
        const [isLoading, setIsLoading] = useState(false);

        // Wrap the custom readArticleHandler function so that we automatically prevent the form from submitting
        // and causing the page to reload. The function `readArticleHandler` shouldn't need to know that it has to prevent
        // the internal form from reloading the page.
        const formSubmitHandler = useCallback(async (event) => {
            setIsLoading(true);
            event.preventDefault();
            try {
                await readArticleHandler(event);
            } catch (exc) {
                setIsLoading(false);
            }
        }, [readArticleHandler]);
        return (
            <PaywallCard header={templateSettings.paywall_read_article_header} loginNextUrl={pageUrl}>
                <form onSubmit={formSubmitHandler}>
                    {!!templateSettings.paywall_read_article_text && <div className="read-article__message">
                        {templateSettings.paywall_read_article_text}
                    </div>}
                    <Button
                        successColor={true}
                        fill={true}
                        showLoader={isLoading}
                        text={"Read Article"}
                        data-visibility-tracker="DisplayReadPrompt"
                        data-visibility-tracker-one-shot
                        data-visibility-tracker-arg-page={pageUrl}
                        data-visibility-tracker-arg-views-remaining={paywallStore.views.remaining}
                    />
                </form>
                <div className="read-article__subtext">
                    <b> {paywallStore.views.remaining == 0 ? 'Subscribe today to keep reading great local content. You can cancel anytime!' :
                        paywallStore.views.remaining == 1 ? 'You have 1 free view remaining. Use your last view to read more.' :
                            paywallStore.views.remaining > 1 ? 'You have ' + paywallStore.views.remaining +
                                ' free views remaining. Use one of your views to read more.' : false
                    }</b>
                </div>
            </PaywallCard>
        );
    })
;
